// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-LayoutTitle-LayoutTitle-module__container-gq0xWH","highlight":"src-app-components-forms-LayoutTitle-LayoutTitle-module__highlight-wb7Z8Y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-LayoutTitle-LayoutTitle-module__container-gq0xWH\",\"highlight\":\"src-app-components-forms-LayoutTitle-LayoutTitle-module__highlight-wb7Z8Y\"}";
        // 1789362522822
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  